<script>
export const group = 'TopLeft'
</script>

<script setup>
const gsapTimeline = useGsapTimeline()
defineProps({
  item: Object,
})

const clockElement = ref(null)
const clockElementChildren = ref(null)

onMounted(() => {
  gsapTimeline({ name: 'Clock' })
    .from(clockElement, { letterSpacing: '16px', duration: 0.24, ease: 'power3.Out' }, '<.04')
    .from(shuffle(clockElement.value.children), { scale: 0.5, duration: 0.1, transformOrigin: 'bottom left', stagger: { amount: 0.1 }, ease: 'power1.Out' }, '<')
})

const { onDisappear } = useDisappearable()
onDisappear(async () => await gsapTimeline({ name: 'Clock Disappaer' }).to(clockElement, { letterSpacing: '-6px', duration: 0.125, ease: 'power3.In' }).to(clockElement, { visibility: 'hidden' }))

const { hour, minutes, tearDownClock } = useClock()
onUnmounted(tearDownClock)
const clockText = computed(() => `${hour.value}:${minutes.value}`)
</script>

<template>
  <SplitCharacters :text="clockText" class="text-white text-[40px] font-semibold" @container="clockElement = $event" @children="clockElementChildren = $event" />
</template>
